import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
export function FinalCTA() {
  return <section className="border-t-4 border-volt bg-graphite px-3 py-4 text-center sm:px-6" data-id="element-50" data-mp="3udf8az5tp7i7">
      <div className="mx-auto max-w-xl" data-id="element-51" data-mp="c7tw1mrnowv3">
        <h2 className="font-display text-[1.7rem] font-bold uppercase leading-none text-white sm:text-[2.3rem]" data-id="element-52" data-mp="c4o84aurk10y">
          ONE LAST <span className="text-volt" data-id="element-53" data-mp="m4yi7mli4sbw">QUESTION</span>
        </h2>
        <p className="mt-1.5 text-[0.8rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-54" data-mp="m3416jdcpkd3">
          When a generator won't start, produces no power, loses voltage, trips under load, shuts
          down unexpectedly or displays an unexplained alarm...
        </p>
        <p className="mt-1 font-display text-[1.2rem] font-bold uppercase leading-tight text-volt sm:text-[1.5rem]" data-id="element-55" data-mp="qwq2jfe2e1tl">
          Do you know exactly what you should test next?
        </p>
        <p className="mt-1 text-[0.8rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-56" data-mp="zwv77hrvim42">
          Stop jumping between scattered references and replacing components before confirming what
          is actually causing the fault.
        </p>
        <p className="mt-1 text-[0.76rem] font-extrabold uppercase tracking-wide text-white sm:text-[0.9rem]" data-id="element-57" data-mp="2h3ztyb79amqf">
          Observe the symptom. Test the system. Isolate the cause. Verify the repair.
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[250px] sm:max-w-[310px]" data-id="element-58" data-mp="2qzufpf6s0xxf" />

        <p className="mt-2 font-display text-[1.4rem] font-bold uppercase leading-none text-white sm:text-[1.9rem]" data-id="element-59" data-mp="2v2zi7hquwzm2">
          ⚡ GENERATOR <span className="text-volt" data-id="element-60" data-mp="300944nf1et55">DIAGNOSTIC PRO™</span>
        </p>
        <p className="mt-1 text-[0.66rem] font-bold uppercase tracking-wide text-steel sm:text-[0.82rem]" data-id="element-61" data-mp="34tu6ernny9a5">
          THE COMPLETE FAULT-FINDING SYSTEM FOR GENERATOR TECHNICIANS
        </p>
        <p className="mt-0.5 text-[0.64rem] font-bold uppercase tracking-[0.12em] text-volt sm:text-[0.78rem]" data-id="element-62" data-mp="3est2zbv5megs">
          Observe • Test • Isolate • Diagnose • Verify
        </p>

        <div className="mx-auto mt-2 max-w-md" data-id="element-63" data-mp="1jnk1e5sjjqs4">
          <p className="text-[0.8rem] font-black uppercase tracking-wide text-white sm:text-[0.95rem]" data-id="element-64" data-mp="1jm8y0730cl1j">
            🔥 GET THE COMPLETE SYSTEM TODAY
          </p>
          <div className="mt-1.5" data-id="element-65" data-mp="1shoukvv5deat">
            <CTAButton label="⚡ GET GENERATOR DIAGNOSTIC PRO™" data-id="element-66" data-mp="1sirolcnrnwuy" />
          </div>
          <p className="mt-2 text-[0.66rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-67" data-mp="1nodq31dt59m2">
            Immediate Access • Digital Delivery
          </p>
          <p className="mt-0.5 text-[0.66rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-68" data-mp="1xgjclvlaiytv">
            🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}